import { Outlet, useLocation } from "react-router-dom";
import { useState } from "react";
import Navbar from "../../../layout/Navbar";
import ClientPortalSidebar from "./ClientPortalSidebar";

export default function ClientPortalLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  return (
    <div className="app-shell">
      <ClientPortalSidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />

      <div className="app-main">
        <Navbar onMenuToggle={() => setSidebarOpen((open) => !open)} />

        <main className="app-content">
          <div key={location.pathname} className="content-inner page-enter">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
